// Terminal toasts auto-dismiss quickly. Errors and warnings stay up longer —
// batch failures carry multi-line descriptions worth reading.
export const TOAST_SUCCESS_DURATION_MS = 2_000;
export const TOAST_ERROR_DURATION_MS = 10_000;
